import { default as _91id_93eydODPDvICMeta } from "/srv/node/app/pages/datasources/[id].vue?macro=true";
import { default as _91id_93PTtRi3EU4rMeta } from "/srv/node/app/pages/documents/[id].vue?macro=true";
import { default as indexxBgaXt0NocMeta } from "/srv/node/app/pages/documents/index.vue?macro=true";
import { default as indexNHoxYN1tIeMeta } from "/srv/node/app/pages/hardware/config/index.vue?macro=true";
import { default as index3XKKngsocQMeta } from "/srv/node/app/pages/hardware/index.vue?macro=true";
import { default as indexspapEOacWuMeta } from "/srv/node/app/pages/index.vue?macro=true";
import { default as loginqyaFPxDnoAMeta } from "/srv/node/app/pages/login.vue?macro=true";
import { default as _91month_93cIK2e8igtmMeta } from "/srv/node/app/pages/rentals-v2/billing/[month].vue?macro=true";
import { default as indexQ2fS6DqixsMeta } from "/srv/node/app/pages/rentals-v2/billing/index.vue?macro=true";
import { default as _91id_93v9zmVzSwgTMeta } from "/srv/node/app/pages/rentals-v2/device/[id].vue?macro=true";
import { default as excelOxfq2Bb9PMMeta } from "/srv/node/app/pages/rentals-v2/excel.vue?macro=true";
import { default as indexzX3bQQEbptMeta } from "/srv/node/app/pages/rentals-v2/index.vue?macro=true";
import { default as _91id_939nyyaIWLnCMeta } from "/srv/node/app/pages/rentals-v2/location/[id].vue?macro=true";
import { default as runs3DMgE0V4DhMeta } from "/srv/node/app/pages/rentals-v2/runs.vue?macro=true";
import { default as _91id_93Hee5QPbmr0Meta } from "/srv/node/app/pages/rentals/[id].vue?macro=true";
import { default as _91id_93KQSHl7d4xuMeta } from "/srv/node/app/pages/rentals/device/[id].vue?macro=true";
import { default as indexIMad8QTqWEMeta } from "/srv/node/app/pages/rentals/index.vue?macro=true";
import { default as _91id_93tixyEHLkP2Meta } from "/srv/node/app/pages/reports/filling/calculated/[id].vue?macro=true";
import { default as _91id_93yB6QEjF6NYMeta } from "/srv/node/app/pages/reports/filling/manual/[id].vue?macro=true";
import { default as indexqde7GlOrJpMeta } from "/srv/node/app/pages/reports/index.vue?macro=true";
import { default as _91id_93lwtmybmSSWMeta } from "/srv/node/app/pages/tickets/[id].vue?macro=true";
import { default as indexKBixUUT4euMeta } from "/srv/node/app/pages/tickets/index.vue?macro=true";
import { default as _91id_93bfOiumylYKMeta } from "/srv/node/app/pages/uns/[id].vue?macro=true";
import { default as indexKZTemiyjBzMeta } from "/srv/node/app/pages/uns/index.vue?macro=true";
import { default as _91id_933FKau1EJMUMeta } from "/srv/node/app/pages/uns/mqtt/[id].vue?macro=true";
import { default as indexzBaW4stVaOMeta } from "/srv/node/app/pages/uns/mqtt/index.vue?macro=true";
export default [
  {
    name: _91id_93eydODPDvICMeta?.name ?? "datasources-id",
    path: _91id_93eydODPDvICMeta?.path ?? "/datasources/:id()",
    meta: _91id_93eydODPDvICMeta || {},
    alias: _91id_93eydODPDvICMeta?.alias || [],
    redirect: _91id_93eydODPDvICMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/datasources/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93PTtRi3EU4rMeta?.name ?? "documents-id",
    path: _91id_93PTtRi3EU4rMeta?.path ?? "/documents/:id()",
    meta: _91id_93PTtRi3EU4rMeta || {},
    alias: _91id_93PTtRi3EU4rMeta?.alias || [],
    redirect: _91id_93PTtRi3EU4rMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/documents/[id].vue").then(m => m.default || m)
  },
  {
    name: indexxBgaXt0NocMeta?.name ?? "documents",
    path: indexxBgaXt0NocMeta?.path ?? "/documents",
    meta: indexxBgaXt0NocMeta || {},
    alias: indexxBgaXt0NocMeta?.alias || [],
    redirect: indexxBgaXt0NocMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/documents/index.vue").then(m => m.default || m)
  },
  {
    name: indexNHoxYN1tIeMeta?.name ?? "hardware-config",
    path: indexNHoxYN1tIeMeta?.path ?? "/hardware/config",
    meta: indexNHoxYN1tIeMeta || {},
    alias: indexNHoxYN1tIeMeta?.alias || [],
    redirect: indexNHoxYN1tIeMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/hardware/config/index.vue").then(m => m.default || m)
  },
  {
    name: index3XKKngsocQMeta?.name ?? "hardware",
    path: index3XKKngsocQMeta?.path ?? "/hardware",
    meta: index3XKKngsocQMeta || {},
    alias: index3XKKngsocQMeta?.alias || [],
    redirect: index3XKKngsocQMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/hardware/index.vue").then(m => m.default || m)
  },
  {
    name: indexspapEOacWuMeta?.name ?? "index",
    path: indexspapEOacWuMeta?.path ?? "/",
    meta: indexspapEOacWuMeta || {},
    alias: indexspapEOacWuMeta?.alias || [],
    redirect: indexspapEOacWuMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginqyaFPxDnoAMeta?.name ?? "login",
    path: loginqyaFPxDnoAMeta?.path ?? "/login",
    meta: loginqyaFPxDnoAMeta || {},
    alias: loginqyaFPxDnoAMeta?.alias || [],
    redirect: loginqyaFPxDnoAMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: _91month_93cIK2e8igtmMeta?.name ?? "rentals-v2-billing-month",
    path: _91month_93cIK2e8igtmMeta?.path ?? "/rentals-v2/billing/:month()",
    meta: _91month_93cIK2e8igtmMeta || {},
    alias: _91month_93cIK2e8igtmMeta?.alias || [],
    redirect: _91month_93cIK2e8igtmMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/rentals-v2/billing/[month].vue").then(m => m.default || m)
  },
  {
    name: indexQ2fS6DqixsMeta?.name ?? "rentals-v2-billing",
    path: indexQ2fS6DqixsMeta?.path ?? "/rentals-v2/billing",
    meta: indexQ2fS6DqixsMeta || {},
    alias: indexQ2fS6DqixsMeta?.alias || [],
    redirect: indexQ2fS6DqixsMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/rentals-v2/billing/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93v9zmVzSwgTMeta?.name ?? "rentals-v2-device-id",
    path: _91id_93v9zmVzSwgTMeta?.path ?? "/rentals-v2/device/:id()",
    meta: _91id_93v9zmVzSwgTMeta || {},
    alias: _91id_93v9zmVzSwgTMeta?.alias || [],
    redirect: _91id_93v9zmVzSwgTMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/rentals-v2/device/[id].vue").then(m => m.default || m)
  },
  {
    name: excelOxfq2Bb9PMMeta?.name ?? "rentals-v2-excel",
    path: excelOxfq2Bb9PMMeta?.path ?? "/rentals-v2/excel",
    meta: excelOxfq2Bb9PMMeta || {},
    alias: excelOxfq2Bb9PMMeta?.alias || [],
    redirect: excelOxfq2Bb9PMMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/rentals-v2/excel.vue").then(m => m.default || m)
  },
  {
    name: indexzX3bQQEbptMeta?.name ?? "rentals-v2",
    path: indexzX3bQQEbptMeta?.path ?? "/rentals-v2",
    meta: indexzX3bQQEbptMeta || {},
    alias: indexzX3bQQEbptMeta?.alias || [],
    redirect: indexzX3bQQEbptMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/rentals-v2/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_939nyyaIWLnCMeta?.name ?? "rentals-v2-location-id",
    path: _91id_939nyyaIWLnCMeta?.path ?? "/rentals-v2/location/:id()",
    meta: _91id_939nyyaIWLnCMeta || {},
    alias: _91id_939nyyaIWLnCMeta?.alias || [],
    redirect: _91id_939nyyaIWLnCMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/rentals-v2/location/[id].vue").then(m => m.default || m)
  },
  {
    name: runs3DMgE0V4DhMeta?.name ?? "rentals-v2-runs",
    path: runs3DMgE0V4DhMeta?.path ?? "/rentals-v2/runs",
    meta: runs3DMgE0V4DhMeta || {},
    alias: runs3DMgE0V4DhMeta?.alias || [],
    redirect: runs3DMgE0V4DhMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/rentals-v2/runs.vue").then(m => m.default || m)
  },
  {
    name: _91id_93Hee5QPbmr0Meta?.name ?? "rentals-id",
    path: _91id_93Hee5QPbmr0Meta?.path ?? "/rentals/:id()",
    meta: _91id_93Hee5QPbmr0Meta || {},
    alias: _91id_93Hee5QPbmr0Meta?.alias || [],
    redirect: _91id_93Hee5QPbmr0Meta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/rentals/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93KQSHl7d4xuMeta?.name ?? "rentals-device-id",
    path: _91id_93KQSHl7d4xuMeta?.path ?? "/rentals/device/:id()",
    meta: _91id_93KQSHl7d4xuMeta || {},
    alias: _91id_93KQSHl7d4xuMeta?.alias || [],
    redirect: _91id_93KQSHl7d4xuMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/rentals/device/[id].vue").then(m => m.default || m)
  },
  {
    name: indexIMad8QTqWEMeta?.name ?? "rentals",
    path: indexIMad8QTqWEMeta?.path ?? "/rentals",
    meta: indexIMad8QTqWEMeta || {},
    alias: indexIMad8QTqWEMeta?.alias || [],
    redirect: indexIMad8QTqWEMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/rentals/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93tixyEHLkP2Meta?.name ?? "reports-filling-calculated-id",
    path: _91id_93tixyEHLkP2Meta?.path ?? "/reports/filling/calculated/:id()",
    meta: _91id_93tixyEHLkP2Meta || {},
    alias: _91id_93tixyEHLkP2Meta?.alias || [],
    redirect: _91id_93tixyEHLkP2Meta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/reports/filling/calculated/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93yB6QEjF6NYMeta?.name ?? "reports-filling-manual-id",
    path: _91id_93yB6QEjF6NYMeta?.path ?? "/reports/filling/manual/:id()",
    meta: _91id_93yB6QEjF6NYMeta || {},
    alias: _91id_93yB6QEjF6NYMeta?.alias || [],
    redirect: _91id_93yB6QEjF6NYMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/reports/filling/manual/[id].vue").then(m => m.default || m)
  },
  {
    name: indexqde7GlOrJpMeta?.name ?? "reports",
    path: indexqde7GlOrJpMeta?.path ?? "/reports",
    meta: indexqde7GlOrJpMeta || {},
    alias: indexqde7GlOrJpMeta?.alias || [],
    redirect: indexqde7GlOrJpMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/reports/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93lwtmybmSSWMeta?.name ?? "tickets-id",
    path: _91id_93lwtmybmSSWMeta?.path ?? "/tickets/:id()",
    meta: _91id_93lwtmybmSSWMeta || {},
    alias: _91id_93lwtmybmSSWMeta?.alias || [],
    redirect: _91id_93lwtmybmSSWMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/tickets/[id].vue").then(m => m.default || m)
  },
  {
    name: indexKBixUUT4euMeta?.name ?? "tickets",
    path: indexKBixUUT4euMeta?.path ?? "/tickets",
    meta: indexKBixUUT4euMeta || {},
    alias: indexKBixUUT4euMeta?.alias || [],
    redirect: indexKBixUUT4euMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/tickets/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93bfOiumylYKMeta?.name ?? "uns-id",
    path: _91id_93bfOiumylYKMeta?.path ?? "/uns/:id()",
    meta: _91id_93bfOiumylYKMeta || {},
    alias: _91id_93bfOiumylYKMeta?.alias || [],
    redirect: _91id_93bfOiumylYKMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/uns/[id].vue").then(m => m.default || m)
  },
  {
    name: indexKZTemiyjBzMeta?.name ?? "uns",
    path: indexKZTemiyjBzMeta?.path ?? "/uns",
    meta: indexKZTemiyjBzMeta || {},
    alias: indexKZTemiyjBzMeta?.alias || [],
    redirect: indexKZTemiyjBzMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/uns/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_933FKau1EJMUMeta?.name ?? "uns-mqtt-id",
    path: _91id_933FKau1EJMUMeta?.path ?? "/uns/mqtt/:id()",
    meta: _91id_933FKau1EJMUMeta || {},
    alias: _91id_933FKau1EJMUMeta?.alias || [],
    redirect: _91id_933FKau1EJMUMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/uns/mqtt/[id].vue").then(m => m.default || m)
  },
  {
    name: indexzBaW4stVaOMeta?.name ?? "uns-mqtt",
    path: indexzBaW4stVaOMeta?.path ?? "/uns/mqtt",
    meta: indexzBaW4stVaOMeta || {},
    alias: indexzBaW4stVaOMeta?.alias || [],
    redirect: indexzBaW4stVaOMeta?.redirect || undefined,
    component: () => import("/srv/node/app/pages/uns/mqtt/index.vue").then(m => m.default || m)
  }
]